<template>
<div class="chapter">
<div class="inner_page">
<p class="imgcenter"><img alt="image" id="img9" src="images/img9.jpg"/></p>
<p class="caption">On horseback in Mexico, leading the hunt for the revolutionary leader Pancho Villa, Pershing leads his command across a river. 3US</p>
<p class="caption">President Wilson named Pershing as commander-in-chief, a post he retained for the duration. Pershing, who was a major general, was promoted to full general in the National Army, and was made responsible for the organization, training, and supply of a combined professional and draft Army and National Guard force that eventually grew from 27,000 inexperienced men to two Armies totalling over two million soldiers.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01g_AMERICAN_EXPEDITIONARY_FORCE.vue?43b28a32